import { render } from "./JovenDashboard.vue?vue&type=template&id=0d0a4b4a&scoped=true"
import script from "./JovenDashboard.vue?vue&type=script&lang=js"
export * from "./JovenDashboard.vue?vue&type=script&lang=js"

import "./JovenDashboard.vue?vue&type=style&index=0&id=0d0a4b4a&lang=scss&scoped=true"
import "./JovenDashboard.vue?vue&type=style&index=1&id=0d0a4b4a&lang=css"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0a4b4a"]])

export default __exports__